<template>
  <v-container>
    <v-row class="mx-16" v-if="!showActions">
      <v-col cols="4">
        <v-alert outlined type="success" text>
          Product {{ retrievedProduct.SKU }} described succesfully!
          <v-icon color="success"> mdi-arrow-down-circle</v-icon>
        </v-alert>
      </v-col>
    </v-row>
    <v-layout justify-center>
      <v-card width="90%">
        <v-card-title class="headline footer basic--text">
          <v-row>
            <v-col cols="auto">
              {{ retrievedProduct.SKU }}
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="auto">
              <v-btn small color="secondary" text @click="openProductHistory(retrievedProduct)">
                product history <v-icon right>mdi-eye</v-icon>
              </v-btn>
            </v-col>

            <v-col cols="auto" v-if="retrievedProduct.ExportState">
              <v-chip small :color="exportStateColor(retrievedProduct.ExportState)">
                <span class="font-weight-medium">{{
                  retrievedProduct.ExportState
                }}</span>
              </v-chip>
            </v-col>
          </v-row>
        </v-card-title>

        <v-row class="px-4" align-content="space-between">
          <v-col class="my-2" cols="2" v-if="filesToShow && filesToShow.length > 0">
            <span v-for="(item, i) in filesToShow.slice(0, 2)" :key="i">
              <expandable-image :src="item" class="my-1"> </expandable-image>
              <v-divider></v-divider>
            </span>
          </v-col>
          <v-col class="my-2" cols="2" v-else>
            <v-img max-width="200" src="../../assets/no_image.png"> </v-img>
          </v-col>
          <v-col cols="10">
            <v-row>
              <h3 class="my-4 px-3 basic--text">
                {{ retrievedProduct.Category }}
              </h3>
            </v-row>
            <v-divider></v-divider>
            <v-row>
              <v-col cols="6">
                <v-simple-table dense>
                  <template v-slot:default>
                    <tbody>
                      <tr style="height: 20" v-for="item in stringValues" :key="item.name">
                        <td style="font-weight: 700">{{ item.name }}:</td>
                        <td v-if="item.value === 'No'">
                          <v-icon color="red">mdi-close-circle</v-icon>
                        </td>
                        <td v-else-if="item.value === 'Yes'">
                          <v-icon color="green">mdi-checkbox-marked-circle</v-icon>
                        </td>
                        <td v-else>{{ item.value }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
              <v-col cols="6">
                <v-simple-table dense>
                  <template v-slot:default>
                    <tbody>
                      <tr style="height: 20" v-for="item in simpleArrays" :key="item.name">
                        <td style="font-weight: 700">{{ item.name }}:</td>
                        <td>
                          <span v-for="(word, i) in item.value" :key="i">{{ word
                          }}<span v-if="i !== item.value.length - 1">, </span>
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>

                <div>
                  <v-simple-table dense>
                    <template v-slot:default>
                      <tbody>
                        <tr style="height: 20" v-for="item in simpleObjects" :key="item.name">
                          <td style="font-weight: 700">{{ item.name }}:</td>
                          <td>
                            <span v-for="[key, value] of Object.entries(item.value)" :key="key">
                              {{ key }}: {{ value }},
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                  <v-divider></v-divider>
                </div>
                <div v-if="retrievedProduct.Measurement !== undefined">
                  <v-simple-table dense>
                    <template v-slot:default>
                      <tbody>
                        <tr>
                          <td style="font-weight: 700; width: 30%">
                            Measurements:
                          </td>
                          <td>
                            <ProductObjects :items="retrievedProduct.Measurement"></ProductObjects>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                  <v-divider></v-divider>
                </div>
                <div v-if="retrievedProduct.Size !== undefined">
                  <v-simple-table dense>
                    <template v-slot:default>
                      <tbody>
                        <tr>
                          <td style="font-weight: 700; width: 30%">Sizes:</td>
                          <td>
                            <ProductObjects :items="retrievedProduct.Size"></ProductObjects>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                  <v-divider></v-divider>
                </div>
                <div v-if="retrievedProduct.Other !== undefined">
                  <v-simple-table dense>
                    <template v-slot:default>
                      <tbody>
                        <tr>
                          <td style="font-weight: 700; width: 30%">Other:</td>
                          <td>
                            <ProductObjects :items="retrievedProduct.Other"></ProductObjects>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                  <v-divider></v-divider>
                </div>
                <div v-if="retrievedProduct.Composition !== undefined">
                  <v-simple-table dense>
                    <template v-slot:default>
                      <tbody>
                        <tr>
                          <td style="font-weight: 700; width: 30%">
                            Compositions:
                          </td>
                          <td>
                            <Compositions :compositions="retrievedProduct.Composition"></Compositions>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                  <v-divider></v-divider>
                </div>
              </v-col>
            </v-row>
            <v-row v-if="filesToShow && filesToShow.length > 2">
              <v-col class="my-2" cols="2" v-for="(item, i) in filesToShow.slice(2)" :key="i">
                <expandable-image :src="item"> </expandable-image>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-divider></v-divider>

        <!-----BUTTONS WHEN ITEM HAS DESCRIPTION------------------------------------->
        <v-card-actions v-if="hasDescription && showActions">
          <v-spacer></v-spacer>
          <v-btn class="ma-2" color="success" @click="proceedNew"> Skip </v-btn>
          <v-btn class="ma-2" color="success" @click="createNewVariaton">
            New variation
          </v-btn>
          <v-btn class="ma-2" color="success" @click="editDescription">
            Edit
          </v-btn>
        </v-card-actions>
        <!--------------------------------------------------------------------------->
        <v-spacer></v-spacer>
        <!-----BUTTONS WHEN ITEM DOESN'T HAVE DESCRIPTION---------------------------->
        <v-card-actions v-if="withoutDescription && showActions">
          <v-spacer></v-spacer>
          <v-btn class="ma-2" color="success" @click="writeDescription">
            Write description
          </v-btn>
        </v-card-actions>
        <!--------------------------------------------------------------------------->
        <v-card-actions v-if="!showActions">
          <v-spacer></v-spacer>
          <v-btn class="ma-2" color="success" @click="reset">
            Proceed new item
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-layout>

    <ProductHistoryDialog ref="productHistoryDialog"></ProductHistoryDialog>
  </v-container>
</template>

<script>
import ProductObjects from "./ProductObjects.vue";
import Compositions from "./Compositions.vue";
import ProductHistoryDialog from "./ProductHistoryDialog.vue";

export default {
  name: "ProductCard",
  components: {
    ProductObjects,
    Compositions,
    ProductHistoryDialog,
  },
  props: {
    hasDescription: Boolean,
    retrievedProduct: Object,
    filesToShow: Array,
    withoutDescription: Boolean,
    showActions: Boolean,
  },
  computed: {
    sizes() {
      return this.retrievedProduct.Size;
    },
    stringValues() {
      let values = [];
      for (let [key, value] of Object.entries(this.retrievedProduct).sort()) {
        if (
          typeof value === "string" ||
          typeof value === "boolean" ||
          typeof value === "number"
        ) {
          if (
            key !== "ExportState" &&
            key !== "Quantity" &&
            key !== "Location" &&
            key !== "idPath" &&
            key !== "Category" &&
            key !== "isASet" &&
            key !== "SKU" &&
            key !== "descriptionType" &&
            key !== "AttentionMessage" &&
            key !== "Type"
          ) {
            if (key == "StyleCode") {
              key = "Style code";
            } else if (key == "SubBrand") {
              key = "Sub-brand";
            } else if (key == "StyleName") {
              key = "Style name";
            } else if (key == "ManufacturerColor") {
              key = "Manufacturer color";
            } else if (key == "WholesalePrice") {
              key = "Wholesale price";
            } else if (key == "WholesalePrice") {
              key = "Wholesale price";
            } else if (key == "RealColor") {
              key = "Real color";
            } else if (key == "SetOf") {
              key = "Set of";
            } else if (key == "GarmentCare") {
              key = "Garment care";
            } else if (typeof value == "boolean") {
              if (value == true) {
                value = "Yes";
              } else {
                value = "No";
              }
            }
            values.push({ name: key, value: value });
          }
        }
      }
      return values;
    },
    simpleObjects() {
      let values = [];
      // let obj = {}

      for (let [key, value] of Object.entries(this.retrievedProduct)) {
        if (
          typeof value === "object" &&
          key != "Photos" &&
          key != "Composition" &&
          !Array.isArray(value) &&
          key != "Size" &&
          key != "Measurement" &&
          key != "Other"
        ) {
          values.push({ name: key, value: value });
        }
      }

      return values;
    },
    simpleArrays() {
      let values = [];

      for (let [key, value] of Object.entries(this.retrievedProduct)) {
        if (key !== "Photos" && key !== "LinnworksPhotos" && key != "actions") {
          if (Array.isArray(value)) {
            values.push({ name: key, value: value });
          }
        }
      }
      return values;
    },
    formattedCompositions() {
      let values = [];
      for (let [key, value] of Object.entries(
        this.retrievedProduct.Composition
      )) {
        if (Array.isArray(value)) {
          values.push({ name: key, value: value });
        }
      }
      return values;
    },
  },
  data: () => ({}),
  methods: {
    closedDialog() {
      this.$refs.productHistoryDialog.closeDialog();
    },
    openProductHistory(product) {
      this.$refs.productHistoryDialog.showDialog(product);
    },
    exportStateColor(state) {
      let color = "";
      switch (state) {
        case "Not Exported":
          color = "accent";
          break;
        case "Exported":
          color = "success";
          break;
        case "Requires Attention":
          color = "deep-orange lighten-2";
          break;
        default:
          color = "accent";
          break;
      }
      return color;
    },
    showPhoto(url) {
      console.log(url);
      this.$refs.largePhoto.showLarge(true);
    },
    reset() {
      this.$router.go();
    },
    proceedNew() {
      this.$emit("proceedNew");
    },
    createNewVariaton() {
      this.$emit("createNewVariaton");
    },
    editDescription() {
      this.$emit("editDescription");
    },
    writeDescription() {
      this.$emit("writeDescription");
    },
  },
  async mounted() { },
};
</script>
